import {
  SET_ACCOUNT_CARD,
  SET_BALANCE_SHEET_DATA,
  SET_BANK,
  SET_BANK_TRANSACTIONS,
  SET_BUYS_BY_FACTOR,
  SET_BUY_BY_PRODUCTS,
  SET_CAPITALS,
  SET_CREDITORS_AND_DEBTORS,
  SET_FACTOR_PROFIT,
  SET_FACTOR_SUMMARY,
  SET_JOURNALS,
  SET_PRODUCT_CARD,
  SET_PROFIT_AND_LOSS,
  SET_REPORT,
  SET_REPORTS,
  SET_REVIEW_ACCOUNTS,
  SET_SALES_BY_FACTOR,
  SET_SALE_BY_PRODUCTS,
  SET_TAX_REPORT,
  SET_TRIAL_BALANCE,
  SET_USER_LOGS,
} from "../../constants/reportConstants";

const initialState = {
  report: null,
  reports: [],
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REPORT:
      return {
        ...state,
        report: action.report,
      };
    case SET_REPORTS:
      return {
        ...state,
        reports: action.reports,
      };
    case SET_BALANCE_SHEET_DATA:
      return {
        ...state,
        balanceSheet: action.balanceSheet,
      };
    case SET_PROFIT_AND_LOSS:
      return {
        ...state,
        profitAndLoss: action.profitAndLoss,
      };
    case SET_JOURNALS:
      return {
        ...state,
        journals: action.journals,
      };
    case SET_CAPITALS:
      return {
        ...state,
        capitals: action.capitals,
      };
    case SET_TRIAL_BALANCE:
      return {
        ...state,
        trialBalance: action.trialBalance,
        trialBalance_sumAmountFinal:action.sumAmountFinal


      };
    case SET_REVIEW_ACCOUNTS:
      return {
        ...state,
        reviewAccounts: action.reviewAccounts,
      };
    case SET_CREDITORS_AND_DEBTORS:
      return {
        ...state,
        creditorsAndDebtors: action.creditorsAndDebtors,
      };
    case SET_BANK_TRANSACTIONS:
      return {
        ...state,
        bankTransactions: action.bankTransactions,
      };
    case SET_BANK:
      return {
        ...state,
        bank: action.bank,
      };
    case SET_TAX_REPORT:
      return {
        ...state,
        taxReport: action.taxReport,
      };
    case SET_SALE_BY_PRODUCTS:
      return {
        ...state,
        saleByProducts: action.saleByProducts,
      };
    case SET_BUY_BY_PRODUCTS:
      return {
        ...state,
        buyByProducts: action.buyByProducts,
      };
    case SET_BUYS_BY_FACTOR:
      return {
        ...state,
        buysByFactor: action.buysByFactor,
      };
    case SET_SALES_BY_FACTOR:
      return {
        ...state,
        salesByFactor: action.salesByFactor,
      };
    case SET_FACTOR_SUMMARY:
      return {
        ...state,
        factorSummary: action.factorSummary,
      };
    case SET_FACTOR_PROFIT:
      return {
        ...state,
        factorProfit: action.factorProfit,
      };
    case SET_USER_LOGS:
      return {
        ...state,
        userLogs: action.userLogs,
      };
    case SET_ACCOUNT_CARD:
      return {
        ...state,
        person: action.person,
      };
    case SET_PRODUCT_CARD:
      return {
        ...state,
        product: action.product,
      };
    default:
      return state;
  }
};

export default reportReducer;
